"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimDepartment = exports.ClaimChannel = exports.ClaimClosureReason = exports.ClaimSubCategory = exports.ClaimCategory = exports.ClaimType = void 0;
var ClaimType;
(function (ClaimType) {
    ClaimType["CLAIM"] = "claim";
    ClaimType["DISSATISFACTION"] = "dissatisfaction";
    ClaimType["GUARANTEED_RETURN"] = "guaranteed_return";
    ClaimType["NON_COMPLIANCE"] = "non_compliance";
    ClaimType["OTHER"] = "other";
})(ClaimType = exports.ClaimType || (exports.ClaimType = {}));
var ClaimCategory;
(function (ClaimCategory) {
    ClaimCategory["WEBSITE_WORKFLOW"] = "website_workflow";
    ClaimCategory["INTERVENTION_FOLLOWUP"] = "intervention_followup";
    ClaimCategory["PRICE"] = "price";
    ClaimCategory["SERVICE_QUALITY"] = "service_quality";
    ClaimCategory["SHOWING_QUALITY"] = "showing_quality";
    ClaimCategory["PAYMENT_ISSUES"] = "payment_issues";
    ClaimCategory["CANCELLATION"] = "cancellation";
    ClaimCategory["INTERVENTION_DELAY"] = "intervention_delay";
    ClaimCategory["DELAY"] = "delay";
    ClaimCategory["NO_CALL_15MIN"] = "no_call_15min";
    ClaimCategory["NO_CONSTRUCTION_SITE_CLEANUP"] = "no_construction_site_cleanup";
    ClaimCategory["TRADER_BEHAVIOR"] = "trader_behavior";
    ClaimCategory["GUARANTEED_RETURN"] = "guaranteed_return_cat";
    ClaimCategory["INTERVENTION"] = "intervention";
    ClaimCategory["HOMESERVE_MANAGEMENT"] = "homeserve_management";
})(ClaimCategory = exports.ClaimCategory || (exports.ClaimCategory = {}));
var ClaimSubCategory;
(function (ClaimSubCategory) {
    ClaimSubCategory["QUOTE_DIFFERENCE_TIME_SPENT"] = "quote_difference_time_spent";
    ClaimSubCategory["QUOTE_DIFFERENCE_WORK_DONE_OR_TO_BE_DONE"] = "quote_difference_work_done_or_to_be_done";
    ClaimSubCategory["DEFECTS_DAMAGE"] = "defects_damage";
    ClaimSubCategory["QUALITY_OF_THE_SERVICE_PROVIDER_RELATIONSHIP"] = "quality_of_the_service_provider_relationship";
    ClaimSubCategory["REQUEST_PROCESSING_TIME"] = "request_processing_time";
    ClaimSubCategory["HOMESERVE_RELATIONSHIP_QUALITY"] = "homeserve_relationship_quality";
})(ClaimSubCategory = exports.ClaimSubCategory || (exports.ClaimSubCategory = {}));
var ClaimClosureReason;
(function (ClaimClosureReason) {
    ClaimClosureReason["AGREEMENT"] = "agreement";
    ClaimClosureReason["PARTIAL"] = "partial";
    ClaimClosureReason["REFUSAL"] = "refusal";
    ClaimClosureReason["PARTIAL_REFUND"] = "partial_refund";
    ClaimClosureReason["TOTAL_REFUND"] = "total_refund";
    ClaimClosureReason["TRADER_RETURN"] = "trader_return";
    ClaimClosureReason["SEND_OTHER_TRADER"] = "send_other_trader";
    ClaimClosureReason["PROMOTION_COUPON"] = "promotion_coupon";
    ClaimClosureReason["MODERATION"] = "moderation";
})(ClaimClosureReason = exports.ClaimClosureReason || (exports.ClaimClosureReason = {}));
var ClaimChannel;
(function (ClaimChannel) {
    ClaimChannel["VERBAL"] = "verbal";
    ClaimChannel["WRITTEN"] = "written";
})(ClaimChannel = exports.ClaimChannel || (exports.ClaimChannel = {}));
var ClaimDepartment;
(function (ClaimDepartment) {
    ClaimDepartment["INTERVENTION_DEPARTMENT"] = "intervention_department";
    ClaimDepartment["LEGAL_DEPARTMENT"] = "legal_department";
})(ClaimDepartment = exports.ClaimDepartment || (exports.ClaimDepartment = {}));
//# sourceMappingURL=claim.js.map